import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { isTokenExpired, refreshToken, getUserDetails } from './AuthUtil';
import { getDynamicLogo } from '../getDynamicLogo';
import { CircularProgress } from '@mui/material';
import { teleConsultationModel, kioskModel } from '../Axios/AxiosConfig';

const cookies = new Cookies();

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [detailsLoaded, setDetailsLoaded] = useState(false);
  const userDetailsRef = useRef(getUserDetails());

  // 1. Check authentication only once on mount
  useEffect(() => {
    const checkAuthentication = async () => {
      let accessToken = cookies.get('accessToken');

      // Try to refresh if token is expired or missing
      if (!accessToken || isTokenExpired(accessToken)) {
        const refreshed = await refreshToken();
        accessToken = cookies.get('accessToken');

        if (!refreshed || !accessToken || isTokenExpired(accessToken)) {
          setIsAuthenticated(false);
          return;
        }
      }

      setIsAuthenticated(true);
    };

    checkAuthentication();
  }, []);


  useEffect(() => {
    if (isAuthenticated === false) {
      navigate('/login', { state: { from: location } });
    }

    if (isAuthenticated === true) {
      const fetchDoctorDetails = async () => {
        const kioskDetailsCookie = cookies.get('kiosk_details');
        const doctorDetailsCookie = cookies.get('Doctor_details');

        if (kioskDetailsCookie && doctorDetailsCookie) {
          setDetailsLoaded(true);
          return;
        }

        try {
          const id = userDetailsRef.current?.UID || getUserDetails()?.UID;
          if (!id) {
            setDetailsLoaded(true);
            return;
          }

          let kiosk_response = await kioskModel.get(`/KioskSignup/${id}`);
          let doctor_response = await teleConsultationModel.get(`/getDoctor_details/${id}`);

          if (kiosk_response.status === 200) {
            cookies.set('kiosk_details', JSON.stringify(kiosk_response.data), { path: '/', maxAge: 30 * 24 * 60 * 60 });
          }

          if (doctor_response.status === 200) {
            cookies.set('Doctor_details', JSON.stringify(doctor_response.data), { path: '/', maxAge: 30 * 24 * 60 * 60 });
          }
        } catch (error) {
          console.error('Error fetching doctor details:', error);
        } finally {
          setDetailsLoaded(true);
        }
      };

      fetchDoctorDetails();
    }
  }, [isAuthenticated]); // only depends on this to avoid infinite loop

  // 3. While authentication is loading
  if (isAuthenticated === null || (isAuthenticated === true && !detailsLoaded)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh'
      }}>
        <div style={{ position: 'relative', width: '10rem', height: '10rem' }}>
          <CircularProgress style={{ width: '100%', height: '100%', color: 'var(--themePrimaryColor, #DA6E0B)' }} thickness={1} />
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}>
            <img src={getDynamicLogo()} style={{ objectFit: 'contain', width: '80%', height: '80%' }} alt="Loading" />
          </div>
        </div>
      </div>
    );
  }

  return isAuthenticated && detailsLoaded ? children : null;
};

export default ProtectedRoute;
